
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"45","height":"46","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.545 1c-2.75 1.707-5.105 4.738-6.74 8.676C2.168 13.614 1.33 18.268 1.406 23c-.076 4.732.762 9.386 2.397 13.324 1.636 3.938 3.99 6.969 6.741 8.676","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('rect',{attrs:{"x":"15.045","y":"5.5","width":"15","height":"11","rx":"1.5","stroke":"currentColor","stroke-dasharray":"4 4"}}),_c('rect',{attrs:{"x":"15.045","y":"29.5","width":"15","height":"11","rx":"1.5","stroke":"currentColor","stroke-dasharray":"4 4"}}),_c('path',{attrs:{"d":"M34.545 1c2.751 1.707 5.106 4.738 6.741 8.676 1.636 3.938 2.474 8.592 2.398 13.324.076 4.732-.762 9.386-2.398 13.324-1.635 3.938-3.99 6.969-6.74 8.676","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    